export default {
  SET_CHARACTER(state, data) {
    state.character = data
  },
  SET_UNITS(state, data) {
    state.units = data
  },
}
